import { memo } from 'react';

import PropTypes from 'prop-types';

import * as Styled from './ThreadListItem.style';

/**
 * Individual thread item component for the sidebar
 * @param {object} props - Component props
 * @param {object} props.thread - Thread object containing thread data
 * @param {boolean} [props.isActive=false] - Whether this thread is currently active
 * @param {Function} props.onSelect - Callback when thread is selected
 * @returns {React.ReactElement} The ThreadListItem component
 */
function ThreadListItem({ thread, isActive = false, onSelect }) {
  const { threadUuid, title, createdAt } = thread;

  // Format display title with fallback to formatted date and time
  const displayTitle =
    title ||
    `${new Date(createdAt).toLocaleDateString([], {
      month: 'short',
      day: 'numeric'
    })}, ${new Date(createdAt).toLocaleTimeString([], {
      hour: 'numeric',
      minute: '2-digit'
    })}`;

  // Format date for display
  // const displayDate = new Date(lastMessageAt || createdAt).toLocaleDateString([], {
  //   month: 'short',
  //   day: 'numeric'
  // });

  // // Format time for display
  // const displayTime = new Date(lastMessageAt || createdAt).toLocaleTimeString([], {
  //   hour: '2-digit',
  //   minute: '2-digit'
  // });

  const handleClick = () => {
    onSelect(threadUuid);
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      onSelect(threadUuid);
    }
  };

  return (
    <Styled.ThreadItemContainer
      aria-label={`Switch to thread: ${displayTitle}`}
      data-testid={`thread-item-${threadUuid}`}
      isActive={isActive}
      role="button"
      tabIndex={0}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
    >
      <Styled.ThreadContent>
        <Styled.ThreadHeader>
          <Styled.ThreadTitle isActive={isActive} size="sm">
            {displayTitle}
          </Styled.ThreadTitle>
        </Styled.ThreadHeader>
      </Styled.ThreadContent>
    </Styled.ThreadItemContainer>
  );
}

ThreadListItem.propTypes = {
  thread: PropTypes.shape({
    threadUuid: PropTypes.string.isRequired,
    title: PropTypes.string,
    createdAt: PropTypes.string.isRequired,
    messageCount: PropTypes.number
  }).isRequired,
  isActive: PropTypes.bool,
  onSelect: PropTypes.func.isRequired
};

// Memoize to prevent unnecessary re-renders when parent updates
export default memo(ThreadListItem);
